/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'parking': {
    width: 16,
    height: 16,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M233.17 263.21h19.5c34.21 0 66.53-6.84 66.53-48.91 0-32.16-25.65-43.61-57.38-43.61h-28.65v92.52zM192.3 395.5v-255h72.34c50.8 0 97.06 16.42 97.06 73.37 0 59.26-45.83 79.95-99.79 79.95h-28.74V395.5H192.3z" _fill="#1d1d1b" fill-rule="nonzero"/><path pid="1" d="M410.71 431.92c-4.448-4.436-11.597-4.835-16.51-.92-80.749 63.764-195.651 63.764-276.4 0-4.911-3.917-12.059-3.523-16.51.91l-5.83 5.84a12.383 12.383 0 00-3.646 8.773 12.39 12.39 0 004.646 9.667c93.026 74.13 226.054 74.13 319.08 0a12.39 12.39 0 004.646-9.667c0-3.291-1.313-6.451-3.646-8.773l-5.83-5.83zM98.73 77.52c5.85 5.824 15.211 6.418 21.75 1.38 79.726-60.994 191.274-60.994 271 0 6.539 5.038 15.9 4.444 21.75-1.38a16.48 16.48 0 004.852-11.674 16.48 16.48 0 00-6.392-13.026c-91.593-70.201-219.867-70.201-311.46 0a16.48 16.48 0 00-6.392 13.026A16.48 16.48 0 0098.69 77.52h.04z" fill-rule="nonzero"/>'
  }
})
